import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import { useApp } from '../store';

export default function Agent() {
  const { user } = useApp();
  const nav = useNavigate();
  const [stock, setStock]       = useState(0);
  const [transfers, setTrans]   = useState([]);
  const [toUser, setToUser]     = useState('');
  const [qty, setQty]           = useState('');
  const [msg, setMsg]           = useState('');
  const [loading, setL]         = useState(false);

  useEffect(() => {
    API.get('/api/agent/my-stock')
      .then(r => { setStock(r.stock); setTrans(r.transfers); })
      .catch(() => {});
  }, []);

  async function transfer(e) {
    e.preventDefault();
    if (!toUser || !qty) return;
    setL(true); setMsg('');
    try {
      await API.post('/api/agent/transfer-cards', { toUserId: parseInt(toUser), quantity: parseInt(qty) });
      setMsg(`OK:已转移 ${qty} 张房卡给用户 ${toUser}`);
      setStock(s => s - parseInt(qty));
      setToUser(''); setQty('');
    } catch (e) { setMsg(`ERR:${e}`); }
    finally { setL(false); }
  }

  const S = `
    .ag-root{min-height:100vh;
      background:linear-gradient(180deg,#0B1E4A 0%,#0D2B6B 50%,#091840 100%);
      background-attachment:fixed;}
    .ag-header{display:flex;align-items:center;justify-content:space-between;
      padding:52px 20px 20px;border-bottom:1px solid rgba(46,127,232,0.2);}
    .ag-title{font-size:22px;font-weight:900;color:#fff;}
    .ag-badge{display:inline-block;padding:3px 10px;border-radius:99px;
      background:rgba(245,197,24,0.15);color:#F5C518;font-size:12px;font-weight:700;
      margin-left:10px;vertical-align:middle;}
    .ag-back{padding:8px 16px;border-radius:10px;border:1px solid rgba(46,127,232,0.35);
      background:rgba(46,127,232,0.1);color:#8BA8D4;font-size:13px;font-weight:600;cursor:pointer;}
    .ag-main{max-width:700px;margin:0 auto;padding:24px 20px;display:flex;flex-direction:column;gap:16px;}
    .ag-card{background:#0F2554;border:1px solid rgba(46,127,232,0.35);border-radius:16px;
      padding:20px;box-shadow:inset 0 1px 0 rgba(255,255,255,0.07);}
    .ag-card-label{font-size:11px;color:#8BA8D4;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:8px;}
    .ag-stock-num{font-family:'Share Tech Mono',monospace;font-size:48px;font-weight:900;color:#F5C518;line-height:1;}
    .ag-stock-unit{font-size:16px;color:#8BA8D4;margin-left:8px;}
    .ag-desc{font-size:13px;color:#4A6A9A;margin-top:8px;}
    .ag-form{display:flex;flex-direction:column;gap:12px;}
    .ag-msg-ok{padding:10px 14px;border-radius:10px;font-size:13px;
      background:rgba(46,204,113,0.1);border:1px solid rgba(46,204,113,0.3);color:#2ECC71;}
    .ag-msg-err{padding:10px 14px;border-radius:10px;font-size:13px;
      background:rgba(232,69,60,0.1);border:1px solid rgba(232,69,60,0.3);color:#E8453C;}
    .ag-transfer-btn{width:100%;padding:14px;border-radius:12px;border:none;cursor:pointer;
      font-size:15px;font-weight:800;
      background:linear-gradient(180deg,#3A8EF6 0%,#1A5FBF 100%);color:#fff;
      box-shadow:0 4px 0 #0F3A80,0 6px 12px rgba(0,0,0,0.4);}
    .ag-transfer-btn:active{transform:translateY(3px);box-shadow:0 1px 0 #0F3A80;}
    .ag-transfer-btn:disabled{opacity:0.35;cursor:not-allowed;transform:none;box-shadow:none;}
    .ag-rec{display:flex;justify-content:space-between;align-items:center;
      padding:12px 14px;border-radius:10px;background:rgba(46,127,232,0.08);
      border:1px solid rgba(46,127,232,0.2);}
    .ag-rec-name{font-size:14px;font-weight:700;color:#fff;}
    .ag-rec-date{font-size:11px;color:#4A6A9A;margin-top:2px;}
    .ag-rec-qty{font-family:'Share Tech Mono',monospace;color:#F5C518;font-size:18px;font-weight:700;}
    .ag-no-perm{min-height:100vh;display:flex;flex-direction:column;align-items:center;
      justify-content:center;gap:16px;
      background:linear-gradient(180deg,#0B1E4A 0%,#0D2B6B 100%);}
  `;

  if (!user || user.agent_level < 1) {
    return (
      <div>
        <style>{S}</style>
        <div className="ag-no-perm">
          <div style={{fontSize:18,fontWeight:800,color:'#E8453C'}}>无代理权限</div>
          <button className="ag-back" onClick={() => nav('/lobby')}>返回大厅</button>
        </div>
      </div>
    );
  }

  return (
    <div className="ag-root">
      <style>{S}</style>

      <div className="ag-header">
        <div className="ag-title">
          代理后台
          <span className="ag-badge">
            {user.agent_level === 1 ? '一级代理' : '二级代理'}
          </span>
        </div>
        <button className="ag-back" onClick={() => nav('/lobby')}>← 返回大厅</button>
      </div>

      <div className="ag-main">
        <div className="ag-card">
          <div className="ag-card-label">房卡库存</div>
          <div>
            <span className="ag-stock-num">{stock}</span>
            <span className="ag-stock-unit">张</span>
          </div>
          <div className="ag-desc">通过平台2折进货，转移给用户获取差价利润</div>
        </div>

        <div className="ag-card">
          <div className="ag-card-label" style={{marginBottom:14}}>转移房卡给用户</div>
          {msg && (
            <div className={msg.startsWith('OK:') ? 'ag-msg-ok' : 'ag-msg-err'}
              style={{marginBottom:14}}>
              {msg}
            </div>
          )}
          <form className="ag-form" onSubmit={transfer}>
            <input className="input" placeholder="目标用户ID" type="number"
              value={toUser} onChange={e=>setToUser(e.target.value)} required />
            <input className="input" placeholder="转移数量（张）" type="number"
              value={qty} onChange={e=>setQty(e.target.value)} min={1} max={stock} required />
            <button className="ag-transfer-btn" type="submit" disabled={loading || stock < 1}>
              {loading ? '转移中...' : '确认转移'}
            </button>
          </form>
        </div>

        <div className="ag-card">
          <div className="ag-card-label" style={{marginBottom:14}}>转移记录</div>
          {transfers.length === 0 ? (
            <div style={{color:'#4A6A9A',fontSize:14}}>暂无记录</div>
          ) : (
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              {transfers.map((t, i) => (
                <div key={i} className="ag-rec">
                  <div>
                    <div className="ag-rec-name">→ {t.nickname || `用户${t.to_user_id}`}</div>
                    <div className="ag-rec-date">{new Date(t.created_at).toLocaleString('zh-CN')}</div>
                  </div>
                  <div className="ag-rec-qty">{t.quantity} 张</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
